import {createFeatureSelector, createSelector} from '@ngrx/store';
import {PumpState, FEATURE_NAME} from './pump.state';

export const selectPumpState = createFeatureSelector<PumpState>(FEATURE_NAME);

export const selectFilteredPumpsWithCurrentPage = createSelector(
  selectPumpState,
  (state: PumpState) => {
    if (state.filter?.page === null
      || state.filter?.page === undefined
      || !state.pages[state.filter!!.page!!]) {
      return [];
    }

    return state.pages[state.filter!!.page!!]
      .map((id) => state.entities[id]) ?? []
  }
);

export const selectIsPumpsLoading = createSelector(
  selectPumpState,
  (state) => state.isLoading
);

export const selectPumpFilter = createSelector(
  selectPumpState,
  (state) => state.filter
);

export const selectPumpsTotalCount = createSelector(
  selectPumpState,
  (state) => state.totalCount
);

export const selectConnectedValvesByPumpId = (pumpId: string) => createSelector(
  selectPumpState,
  (state) => state.connectedValves[pumpId] ?? []
);

export const selectIsConnectedValvesLoading = createSelector(
  selectPumpState,
  (state) => state.isConnectedValvesLoading
);
